<div class="container text-left">
  <div class="container">
    <form [formGroup]="form">
      <h3 class="subtitulo">Processo</h3>
      <div class="form-row">
        <div class="col-7">
          <app-nro-processo-input formControlName="nroProcesso" [tokenIam]="tokenIam" tipoOrdem="HISTORICO"></app-nro-processo-input>
        </div>
      </div>

      <div class="form-dados-ordem">

        <app-sla-selector [form]="form"></app-sla-selector>

        <app-lista-titulares [titulares]="titulares" [tipoOrdem]='"HISTORICO"' (titularesChange)="onTitularesChange($event)"></app-lista-titulares>

        <h3 class="subtitulo">Período da consulta</h3>
        <div class="form-row">

          <div class="col-8">
            <mat-radio-group [color]="'primary'" [name]="anosHistorico" formControlName="anosHistorico">
              <mat-radio-button value="1" [attr.data-cy]="'radio-historico-1'">1 ano</mat-radio-button>
              <mat-radio-button value="2" [attr.data-cy]="'radio-historico-2'">2 anos</mat-radio-button>
              <mat-radio-button value="3" [attr.data-cy]="'radio-historico-3'">3 anos</mat-radio-button>
              <mat-radio-button value="4" [attr.data-cy]="'radio-historico-4'">4 anos</mat-radio-button>
              <mat-radio-button value="5" [attr.data-cy]="'radio-historico-5'">5 anos</mat-radio-button>
            </mat-radio-group>
          </div>

        </div>

        <div class="row ">
          <div class="col-sm-7"></div>
          <div class="col-sm-5">
            <app-acao-buttons
              [tipoOrdem]="'HISTORICO'"
              (onConfirmar)="consultarHistorico()"
            ></app-acao-buttons>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
